<template>
  <div>
    <v-row>
      <v-col cols="12" sm="3" offset-sm="6" class="py-0">
        <v-text-field
          v-model="search"
          color="dw_green"
          label="Search"
          clearable
          :clear-icon="mdiClose"
          single-line
          hide-details
          class="text-caption">
          <template v-slot:append>
            <v-icon small class="ml-1" v-text="mdiLayersSearchOutline" />
          </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="9">
        <v-data-table
          dense
          :headers="headers"
          :items="toolOptions"
          :search="search"
          item-key="id"
          :single-select="true"
          @click:row="(rowItem) => selectTool(rowItem)"
          class="my-2"
          :footer-props="{
            showFirstLastPage: true,
            firstIcon: mdiPageFirst,
            lastIcon: mdiPageLast,
            prevIcon: mdiChevronLeft,
            nextIcon: mdiChevronRight
          }"
          :options="{
            itemsPerPage: 5
          }"
        >
        </v-data-table>
          <v-card flat color="bg_dark" v-if="selectedTool">
            <v-card-title>{{ selectedTool.name }}</v-card-title>
            <v-card-subtitle class="mb-0 pb-0 font-weight-light">
              {{ selectedTool.description.length === 0 ? '--' : selectedTool.description }}
            </v-card-subtitle>
            <v-card-subtitle class="pt-1 font-weight-light">{{ selectedTool.url }}</v-card-subtitle>
            <v-card-actions>
              <v-btn
                color="red"
                text
                @click="archive"
                title="Remove Tool">
                Remove
                <v-icon v-text="mdiArchiveOutline" small class="ml-2" />
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import {
  mdiArchive,
  mdiArchiveOutline,
  mdiClose,
  mdiLayersSearchOutline,
  mdiPageFirst,
  mdiPageLast,
  mdiChevronLeft,
  mdiChevronRight
} from '@mdi/js';

export default {
  name: 'archiveTools',
  data() {
    return {
      mdiArchive,
      mdiArchiveOutline,
      mdiClose,
      mdiLayersSearchOutline,
      mdiPageFirst,
      mdiPageLast,
      mdiChevronLeft,
      mdiChevronRight,
      search: '',
      headers: [
        { text: 'ID', value: 'id', class: 'font-weight-regular' },
        { text: 'Name', value: 'name', class: 'font-weight-regular' }
      ],
      items: undefined,
      selectedTool: undefined,
      formValid: false
    };
  },
  computed: {
    ...mapGetters([
      'toolOptions'
    ])
  },
  methods: {
    ...mapActions([
      'archiveTool',
      'fetchToolOptions',
      'fetchOriginalByID'

    ]),
    async selectTool(tool) {
      this.selectedTool = await this.fetchOriginalByID(['tool', tool.id]);
    },
    async archive() {
      try {
        await this.archiveTool({
          id: this.selectedTool.id,
          name: this.selectedTool.name,
          archived: true
        });
        this.selectedTool = undefined;
        await this.fetchToolOptions();
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
